(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milli-request"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('milli-special-request')) {
    customElements.define('milli-special-request', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.form = this.querySelector('form');
        if (!this.form || !window.fetch || !window.FormData) return;
        this.initialized = true;
        this.button = this.form.querySelector('[type="submit"]');
        this.error = this.querySelector('[data-request-error]');
        this.errorText = this.querySelector('[data-request-error-text]');
        this.status = this.querySelector('[data-request-status]');
        this.variant = this.form.elements.namedItem('id').value;
        this.storageKey = 'milli-request-id:' + this.variant;
        try { this.requestId = sessionStorage.getItem(this.storageKey); } catch (_) {}
        const savedState = (history.state && history.state.milliSpecialMessage || {})[this.variant];
        if (!this.requestId && savedState) this.requestId = savedState.requestId;
        if (!this.requestId) {
          this.requestId = window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2);
          try { sessionStorage.setItem(this.storageKey, this.requestId); } catch (_) {}
        }
        this.uncertain = Boolean(savedState && savedState.requestId === this.requestId && savedState.uncertain);
        try { this.uncertain = this.uncertain || sessionStorage.getItem(this.mutationKey()) === '1'; } catch (_) {}
        this.submitHandler = event => {
          event.preventDefault();
          if (this.pending || this.uncertain || !this.form.reportValidity()) return;
          this.submitRequest();
        };
        this.form.addEventListener('submit', this.submitHandler);
        this.restore = event => {
          if (!event.persisted) return;
          this.setBusy(false);
          this.status.hidden = true;
        };
        window.addEventListener('pageshow', this.restore);
        if (this.uncertain) {
          this.showUncertainError();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.restore);
        if (this.form && this.submitHandler) this.form.removeEventListener('submit', this.submitHandler);
        if (this.form) this.setBusy(false);
        this.initialized = false;
      }

      setBusy(busy) {
        this.pending = busy;
        this.form.setAttribute('aria-busy', String(busy));
        this.button.disabled = busy || this.uncertain;
        if (busy) {
          this.disabledControls = [...this.form.elements].filter(control => control !== this.button && !control.disabled);
          this.disabledControls.forEach(control => { control.disabled = true; });
        } else if (this.disabledControls) {
          this.disabledControls.forEach(control => { control.disabled = false; });
          this.disabledControls = null;
        }
      }

      mutationKey() {
        return 'milli-request-pending:' + this.variant + ':' + this.requestId;
      }

      markMutation(uncertain) {
        this.uncertain = uncertain;
        try {
          if (uncertain) sessionStorage.setItem(this.mutationKey(), '1');
          else sessionStorage.removeItem(this.mutationKey());
        } catch (_) {}
        try {
          const state = history.state || {};
          history.replaceState({ ...state, milliSpecialMessage: { ...(state.milliSpecialMessage || {}), [this.variant]: { requestId: this.requestId, uncertain } } }, '');
        } catch (_) {}
      }

      showUncertainError() {
        this.errorText.textContent = this.dataset.uncertainError;
        this.error.hidden = false;
        this.status.hidden = true;
        this.setBusy(false);
      }

      async request(url, body) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(url, {
            method: body ? 'POST' : 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
            ...(body ? { body: JSON.stringify(body) } : {}),
            signal: controller.signal
          });
          if (!response.ok) {
            const error = new Error(this.dataset.error);
            error.definitive = response.status >= 400 && response.status < 500;
            throw error;
          }
          return await response.json();
        } finally {
          clearTimeout(timeout);
        }
      }

      matches(item, properties) {
        return String(item.variant_id) === this.variant && Object.entries(properties).every(([key, value]) => key.startsWith('_') || String((item.properties || {})[key] || '') === value);
      }

      async submitRequest() {
        const properties = {};
        for (const [name, value] of new FormData(this.form)) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = String(value).trim();
        }
        for (const control of this.form.querySelectorAll('[required]')) {
          if (!control.value.trim()) {
            control.value = '';
            control.reportValidity();
            return;
          }
        }
        properties._milli_request_id = this.requestId;
        this.error.hidden = true;
        this.status.textContent = this.dataset.loading;
        this.status.hidden = false;
        this.setBusy(true);
        const run = async () => {
          let mutationStarted = false;
          try {
            const cart = await this.request(this.dataset.cartUrl + '.js');
            const existing = cart.items.find(item => String(item.variant_id) === this.variant && (item.properties || {})._milli_request_id === this.requestId)
              || cart.items.find(item => this.matches(item, properties));
            if (existing) {
              const existingRequestId = (existing.properties || {})._milli_request_id;
              if (existingRequestId) {
                this.requestId = existingRequestId;
                properties._milli_request_id = existingRequestId;
                try { sessionStorage.setItem(this.storageKey, existingRequestId); } catch (_) {}
              }
              if (!this.matches(existing, properties) || existing.quantity !== 1) {
                mutationStarted = true;
                this.markMutation(true);
                await this.request(this.dataset.changeUrl + '.js', {
                  id: existing.key,
                  quantity: 1,
                  properties: { ...(existing.properties || {}), ...properties }
                });
              }
            } else {
              mutationStarted = true;
              this.markMutation(true);
              const added = await this.request(this.dataset.addUrl + '.js', { items: [{ id: this.variant, quantity: 1, properties }] });
              const addedItem = (added.items || [added]).find(item => this.matches(item, properties));
              if (!addedItem) throw new Error(this.dataset.uncertainError);
              if (addedItem.quantity !== 1) {
                await this.request(this.dataset.changeUrl + '.js', { id: addedItem.key, quantity: 1 });
              }
            }
            this.markMutation(false);
            window.location.assign(this.dataset.checkoutUrl);
          } catch (error) {
            if (mutationStarted) {
              try {
                const cart = await this.request(this.dataset.cartUrl + '.js');
                const addedItem = cart.items.find(item => this.matches(item, properties) && (item.properties || {})._milli_request_id === this.requestId);
                if (addedItem) {
                  if (addedItem.quantity !== 1) {
                    await this.request(this.dataset.changeUrl + '.js', { id: addedItem.key, quantity: 1 });
                  }
                  this.markMutation(false);
                  window.location.assign(this.dataset.checkoutUrl);
                  return;
                }
              } catch (_) {}
            }
            if (mutationStarted && !error.definitive) {
              this.showUncertainError();
              this.error.focus();
              return;
            }
            this.markMutation(false);
            this.errorText.textContent = this.dataset.error;
            this.error.hidden = false;
            this.status.hidden = true;
            this.setBusy(false);
            this.error.focus();
          }
        };
        if (navigator.locks) {
          await navigator.locks.request('milli-special-message-cart', run);
        } else {
          await run();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
